import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tableRowLabel: {
    fontWeight: "bold",
    paddingRight: 20,
    whiteSpace: "nowrap",
    width: 160,
  },
  resolutionTable: {
    marginLeft: 30,
    marginRight: 30,
    marginTop: 30,
    fontSize: 16,
    height: 80,
    "& td": {
      paddingBottom: 15,
      verticalAlign: "top",
    },
  },
}));

const FindingsResolutionNotes = (props) => {
  const classes = useStyles();

  const resolutionOptions = [
    { value: 10, label: "Valid" },
    { value: 20, label: "False Positive" },
    { value: 30, label: "No Action Needed" },
    { value: 40, label: "Risk Accepted" },
  ];

  const findingResolutionValue = resolutionOptions.find(
    (r) => r.value === props.finding.resolution
  );

  return (
    <table className={classes.resolutionTable}>
      <tbody>
        <tr>
          <td className={classes.tableRowLabel}>Resolution</td>
          <td>{findingResolutionValue?.label}</td>
        </tr>
        <tr>
          <td className={classes.tableRowLabel}>Resolution Notes</td>
          <td>
            {props.finding.resolutionNotes
              ? props.finding.resolutionNotes
              : "This finding does not have any resolution notes at this time."}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default FindingsResolutionNotes;
